/**
 * Created by Ning Jiang on 12/6/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TweenLite} from "gsap";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SpacierArcadeGameAssets} from "../SpacierArcadeGameAssets";

export class SAReelAttentionView extends BaseView {

    private _currentReelId:number;
    private _attention:PIXI.spine.Spine;
    private _attentionArray:PIXI.spine.Spine[];
    private _layer:ScalableLayer;

    constructor() {
        super();
        this.reset();
    }

    protected initAnimations():void {
        this._attentionArray = [];
        this._layer = StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.SPIN_SPINE.name);
        for(let i=0; i < 3; i++) {
            let attention = new PIXI.spine.Spine(GameResources.getSpineAsset(SpacierArcadeGameAssets.W_ANTICIPATION));
            attention.alpha = 0;
            attention.name = (i + 1).toString();
            this._layer.addChild(attention);
            this._attentionArray.push(attention);
        }
    }

    public playNearWin(reelId:number):void {
        this._currentReelId = reelId;
        let attention = this._attentionArray[reelId - 1];
        attention.state.setAnimation(0, "wild_anticipation", true);
        let positionX:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId][0] + GameConfig.instance.REEL_AREA_POS_X - 10;
        let positionY:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId][1] + GameConfig.instance.SYMBOL_HEIGHT * 3.5 + GameConfig.instance.REEL_AREA_POS_Y;
        attention.position.set(positionX, positionY);
        TweenLite.to(attention, 0.2, {alpha : 1});
    }

    public stopNearWin(reelId:number):void {
        let attention = this._attentionArray[reelId - 1];
        TweenLite.to(attention, 0, {alpha : 0, onComplete : () => attention.state.setEmptyAnimation(0, 0)});
    }

    // protected onResize(data:IResizeData):void{
    //     let positionX:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[2][0] + GameConfig.instance.REEL_AREA_POS_X - 10;
    //     let positionY:number = GameConfig.instance.REEL_DISPLAY_POSITIONS[2][1] + GameConfig.instance.SYMBOL_HEIGHT * 3.5 + GameConfig.instance.REEL_AREA_POS_Y;
    //     this._attention.position.set(positionX, positionY);
    // }

    public reset():void {
        this._currentReelId = -1;
    }
}